<script>
  import Navbar from "./components/Navbar.svelte";
  import Title from "./components/Title.svelte";
</script>

<svelte:head>
  <meta charset="utf-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>celver | Streaming Demo</title>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
    integrity="sha512-9usAa10IRO0HhonpyAIVpjrylPvoDwiPUiKdWk5t3PyolY1cOd4DSE0Ga+ri4AuTroPR5aQvXU9xC6qOPnzFeg=="
    crossorigin="anonymous"
    referrerpolicy="no-referrer"
  />
  <link rel="stylesheet" href="/global.css" />
  <style>
    html,
    body {
      padding: 0px;
      margin: 0px;
    }
  </style>
</svelte:head>
<main>
  <section class="hero is-fullheight">
    <!-- Hero head: will stick at the top -->
    <div class="hero-head has-background-white">
      <Navbar />
    </div>

    <!-- Hero content: will be in the middle -->
    <div class="hero-body is-large bgimg">
      <Title />
    </div>
    <!-- <div class="hero-body has-background-info ">

    </div> -->
    <!-- Hero footer: will stick at the bottom -->
    <div class=" has-background-dark has-text-light p-5">
      <div class="container">
        <div class="columns is-centered is-multiline">
          <div class="column has-text-centered is-one-third">
            <h3 class="title is-3 is-family-primary has-text-light">celver</h3>
          </div>

          <div class="column  is-one-third">
            <div class="content">
              <h5 class="title is-5 is-family-primary has-text-light">
                Über celver AG
              </h5>
              <p class="is-family-secondary">
                Die celver AG ist ein Management- und IT-Beratungsunternehmen
                mit den Schwerpunkten Business Intelligence, Corporate
                Performance Management (CPM), Smart Data Architectures, Advanced
                Analytics und Process Mining.
              </p>
            </div>
          </div>

          <div class="column is-one-third">
            <div class="content has-text-light">
              <h5 class="title is-5 is-family-primary has-text-light">
                Kontakt
              </h5>
              <p class="is-family-secondary">
                <b> celver AG </b><br />

                Zirkusweg 1<br />
                D-20359 Hamburg<br />
                Tel.: +49 40 4689964 0<br />
                Fax: +49 40 4689964 99<br />
                E-Mail:
                <a href="mailto:kontakt(at)celver.com"
                  >kontakt(at)celver.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
